import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import RecursiveContainer from "./RecursiveContainer";
import Button from "../ButtonUI";
import {
  formConfigDermatose,
  formConfigTummerCutane,
} from "../../config/formConfig";
import Compressor from "compressorjs";
import Input from "../Input";
import { useAtom } from "jotai";
import { userAtom } from "../../state/auth";
import { refreshAtom } from "../../state/refreshPatientInfo";
import { useDropzone } from "react-dropzone";
import { ReactComponent as Close } from "../../assets/icons/icon-close.svg";
import { has, remove } from "lodash";
import Select from "../Select";
import makeToast from "../Snackbar";
import {
  addDocsByPatient2,
  addDemandByReqDoctor,
  getAllAvailableExperts,
  assignDemandeToExpert,
  analyzeImage,
} from "../../api/medecin";
import { getYupSchemaFromMetaData } from "./yupSchemaCreator";
import Modal from "../ModalUI";
import _ from "lodash";
import alert from "../../assets/images/alert.png";
import "./styles.scss";
import { retriveGroup } from "../../api/groups";
import { getCurrentEvent } from "../../api/screeningEvent";
import HumanCard from "../HumanCard";
import Carousel from "../Carousel";
import { QualityAnalysis } from "./QualityImage";
import { HiCheckCircle } from 'react-icons/hi';
import { MdCameraAlt, MdAccessibilityNew } from 'react-icons/md';
import CameraCapture from "../CameraCapture";

type QualityResult = {
  blur_variance: number;
  brightness_mean: number;
  brightness_status: string;
  contrast_std: number;
  filename: string;
  is_blurry: boolean;
  low_contrast: boolean;
  overall_quality: string;
};

const specialites = [{ label: "Dermatologie", value: "dermatologie" }];
const category = [
  { label: "Dermatose non tumorale", value: "Dermatose non tumorale" },
  { label: "Tumeur cutanée", value: "Tumeurs cutanees" },
];
export const getFieldErrorNames = (formikErrors) => {
  const transformObjectToDotNotation = (
    obj,
    prefix = "",
    result: any[] = []
  ) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (!value) return;

      const nextKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object") {
        transformObjectToDotNotation(value, nextKey, result);
      } else {
        result.push(nextKey);
      }
    });

    return result;
  };

  return transformObjectToDotNotation(formikErrors);
};

const Stepper = ({ currentEntry }) => {
  const steps = ["Selectionner la zone", "Prendre photo"];
  
  const isStep1Done = !!currentEntry.selectedPart;
  const isStep2Done = currentEntry.files?.length > 0;

  return (
    <div className="w-full py-4 mb-8">
      <div className="flex items-center justify-center">
        {steps.map((label, index) => {
          const isCompleted = (index === 0 && isStep1Done) || (index === 1 && isStep2Done);
          const isActive = (index === 0 && !isStep1Done) || (index === 1 && isStep1Done && !isStep2Done);

          return (
            <React.Fragment key={label}>
              <div className="flex flex-col items-center relative">
                <div className={`
                  w-10 h-10 flex items-center justify-center rounded-full border-2 transition-colors duration-300
                  ${isCompleted ? 'bg-green-500 border-green-500 text-white' : 
                    isActive ? 'border-blue-600 text-blue-600' : 'border-gray-300 text-gray-400'}
                `}>
                  {isCompleted ? (
                    <HiCheckCircle size={24} />
                  ) : index === 0 ? (
                    <MdAccessibilityNew size={22} />
                  ) : (
                    <MdCameraAlt size={20} />
                  )}
                </div>
                
                <span className={`absolute -bottom-7 whitespace-nowrap text-xs font-semibold 
                  ${isActive ? 'text-blue-600' : isCompleted ? 'text-green-600' : 'text-gray-400'}`}>
                  {label}
                </span>
              </div>

              {index < steps.length - 1 && (
                <div className={`h-1 w-20 mx-2 transition-colors duration-300 
                  ${isStep1Done ? 'bg-green-500' : 'bg-gray-200'}`} 
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
type ScreeningEvent = {
  _id: string;
  eventDate: string;
  doctorId?: string;
};

const RequestForm: React.FC<any> = ({
  openModal,
  setOpenModal,
  constId,
  patientId,
  gender,
  setPatientAdded,
  setUpoloadProg,
  setUpoloadProgFalse,
}) => {
  const [loading, setLoading] = useState(false);
  const [modalPatientHasDemandInProg, setModalPatientHasDemandInProg] =
    useState(false);
  const [user, setUser] = useAtom(userAtom);
  const [refreshPatientInfo, setRefreshPatientInfo] = useAtom(refreshAtom);
  const [files, setFiles] = useState<any>([]);
  const [takePic, setTakePic] = useState(true);
  const [progress, setProgress] = useState(0);
  const [uploadToast, setUploadToast] = useState(false);
  const [draft, setDraft] = useState(false);
  const [groupData, setGroupData] = useState("") as any;
  const [teleexpertList, setTeleexpertList] = useState<any[]>([]);
  const [previousDoctor, setPreviousDoctor] = useState<any[]>([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [qualityData, setQualityData] = useState<QualityResult | null>(null);
  const [isConfirming, setIsConfirming] = useState(false);

  // const [loadingCompressor, setLoadingCompressor] = useState(false);
  const [confirmationData, setConfirmationData] = useState<{
    values: any;
    formConfig: any;
  }>({
    values: null,
    formConfig: null,
  });
  const [currentEvent, setcurrentEvent] = useState<ScreeningEvent | ScreeningEvent[] >([] as ScreeningEvent[]);
  const [confirm, setConfirm] = useState(false);
  const [entries, setEntries] = useState<
    { selectedPart: string | null; files: File[]; message: string; anciennete: string; taille: string; douleur: "oui" | "non" | "inconnue"; }[]
  >([{ selectedPart: null, files: [], message: "", anciennete: "", taille: "", douleur: "inconnue", }]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentStep, setCurrentStep] = useState(1);
  const currentEntry = entries[currentIndex];
  let isSubmittingRef = useRef(false);


  const hasCurrentEvent =
  Array.isArray(currentEvent)
    ? currentEvent.length > 0
    : Boolean(currentEvent && Object.keys(currentEvent).length > 0);
  const format = ({ size }: Blob) => {
    if (size === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const calculate = (t: number) => {
    return (
      Math.round((performance.now() - t + Number.EPSILON) * 100) / 100 + "ms"
    );
  };

  const [consentementFile, setConsentementFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target;
    const file = input.files?.[0];
    if (!file) return;

    input.value = "";

    const imageTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    const docTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (imageTypes.includes(file.type)) {
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 2048,
        maxHeight: 2048,
        success: (blob) => {
          const compressedFile = new File([blob], file.name, { type: file.type });
          setConsentementFile(compressedFile);
          formik.setFieldValue("withConsentement", true);
          formik2.setFieldValue("withConsentement", true);
          console.log("Image saved:", compressedFile);
        },
        error(err) {
          console.error("Compression error:", err);
        },
      });
    } else if (docTypes.includes(file.type)) {
      setConsentementFile(file);
      formik.setFieldValue("withConsentement", true);
      formik2.setFieldValue("withConsentement", true);
      console.log("file saved:", file);
    } else {
      console.warn("erreur file type:", file.type);
    }
  };

  const removeLastPhoto = () => {
    setEntries(prev => {
      const updated = [...prev];
      updated[currentIndex] = {
        ...updated[currentIndex],
        files: updated[currentIndex].files.slice(0, -1)
      };
      return updated;
    });

    setQualityData(null);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/png, image/jpeg,image/jpg,image/webp",
    onDrop: (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        console.log("Processing file:", file);

        // Compress the file
        new Compressor(file, {
          quality: 0.8,
          maxWidth: 2048,
          maxHeight: 2048,
          success: async (blob) => {
            const compressedFile = new File([blob], file.name, { type: blob.type });
            setEntries(prev =>
              prev.map((entry, idx) => {
                if (idx !== currentIndex) return entry;

                const safeEntry = entry ?? {
                  selectedPart: null,
                  files: [],
                  message: "",
                  anciennete: "",
                  taille: "",
                  douleur: "inconnue",
                };

                return {
                  ...safeEntry,
                  files: [...safeEntry.files, compressedFile],
                };
              })
            );

            try {
              const formData = new FormData();
              formData.append("image", compressedFile);

              const res = await analyzeImage(formData);
              const result = res.data.data.results[0];
              console.log("Analysis result:", result);
              setQualityData(result);
              if (result.overall_quality !== "accept") {
                makeToast("error", "La photo est de mauvaise qualité. Veuillez prendre une autre photo.");

                /*const newEntries = [...entries];
                setEntries(newEntries);*/
              }
              
            } catch (err) {
              console.error("Error sending image for analysis:", err);
            }
          },
        });
      });
    },
  });

  const thumbs = files.map((file) => (
    <div className="thumb" key={file?.preview as any}>
      <div className="thumbInner">
        <button
          className="absolute icon-secondary2"
          onClick={() => {
            setFiles(
              remove([...files], function (n) {
                return n.preview !== file.preview;
              })
            );
          }}
        >
          <Close />
        </button>
        <img src={file.preview} alt="img drop" className="img" />
      </div>
    </div>
  ));

  const injectExpertFromEvent = (values: any) => {
    if (hasCurrentEvent) {
      const expertId = (currentEvent as any)[0]?.docExpert?._id;
      if (expertId) {
        values.expertId = expertId;
      }
    }
    return values;
  };

  const handleDeleteImage = (entryIndex: number, imageIndex: number) => {
    setEntries((prev) => {
      const updated = [...prev];

      if (!updated[entryIndex]) return prev;

      updated[entryIndex] = {
        ...updated[entryIndex],
        files: updated[entryIndex].files.filter(
          (_, idx) => idx !== imageIndex
        ),
      };

      const filtered = updated.filter((entry) => entry.files.length > 0);

      const safeIndex = Math.min(currentIndex, filtered.length - 1);
      setCurrentIndex(Math.max(0, safeIndex));

      if (filtered.length === 0) {
        setConfirm(false);

        return [
          {
            selectedPart: null,
            files: [],
            message: "",
            anciennete: "",
            douleur: "inconnue",
            taille: "",
          },
        ];
      }

      return filtered;
    });
  };

  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  useEffect(() => {
    async function fetchMyAPI(): Promise<void> {
      const response = await getAllAvailableExperts({
        userId: user?._id,
        patientId: patientId,
      });
      setTeleexpertList(response?.filterListOfAvailableDoctor);
      setPreviousDoctor(
        response?.ListPreviousDoctors
          ? response?.ListPreviousDoctors.map((el) => ({
              ...el,
              label:
                el.lastName +
                " " +
                el.firstName +
                " " +
                "(" +
                "a précédemment traité une demande sur ce même patient" +
                ")",
              value: el._id,
            }))
          : []
      );
    }

    fetchMyAPI();
  }, []);

  async function retriveGroupMyAPI() {
    setLoading(true);
    const res = await retriveGroup(user?.groupId);
    setGroupData(res?.response);
    setLoading(false);
    return await res;
  }
  useEffect(() => {
    retriveGroupMyAPI();
  }, []);

  
  useEffect(()=> {
    async function getCurerntEvent() {
      try {
        const currentev = await getCurrentEvent();
        setcurrentEvent(currentev);
      } catch (err) {
        console.error("Failed to fetch current event:", err);
      }
    }
    getCurerntEvent();
  },[])
  const formik = useFormik({
    initialValues: {
      specialite: "",
      type: "",
      constId: constId,
      withPhotos: true,
      doctor_id: user?._id,
      patientId: patientId,
      priseEncharge: false,
      files: files,
      isDraft: draft,
      forceIt: false,
      expertId: "",
      withConsentement: false,
    },

    onSubmit: async (values) => {
      try {

        const event = Array.isArray(currentEvent) ? currentEvent[0] : currentEvent;

        const expertId = (event as any)?.docExpert?._id;

        if (expertId) {
          formik.setFieldValue("expertId", expertId);
        }
        console.log("Expert ID:", values.expertId);
        let formConfig = {};

        if (values.type === "Dermatose non tumorale") {
          formConfig = formConfigDermatose;
        } else if (values.type === "Tumeurs cutanees") {
          formConfig = formConfigTummerCutane;
        }

        const allFiles = entries.flatMap(e => e.files || []);
        values.withPhotos = allFiles.length > 0;
        values.isDraft = draft;

        console.log("allFiles in line 420", allFiles)
        console.log("values.files in line 420", values.files)
        console.log("values.isDraft", values.isDraft)
        //console.log("draft", draft)
        //console.log("values", values)
        if (values.files && values.files.length === 0) {
          console.log("problems no photo line 426",  )
          console.log("values.files", values.files)
          console.log("values.files.length", values.files.length)
          values.withPhotos = false;
        }

        setLoading(true);
        if (values.withPhotos) {
          setUpoloadProg();
          setUploadToast(true);
        }
        if (user?.type == "medecinResponsable") {
          const response = await addDocsByPatient2(
            values,
            formConfig,
            (event: { loaded: number; total: number }) => {
              setProgress(Math.round((100 * event.loaded) / event.total));

              return event.loaded;
            }
          );
          if (response.status === "Success") {
            setDraft(false);
            setLoading(false);
            setPatientAdded(true);
            makeToast("success", response.message);
            setRefreshPatientInfo({ state: !refreshPatientInfo?.state });
            setOpenModal(false);
          } else if (response.status === "info") {
            //setDraft(false);
            setUpoloadProgFalse();
            setUploadToast(false);
            setModalPatientHasDemandInProg(true);
            makeToast("info", response.message);
            setLoading(false);
          } else {
            setLoading(false);
            makeToast("error", response.message);
            setOpenModal(false);
          }
        } else if (user?.type == "medecin" && _.isEmpty(teleexpertList)) {
          console.log("1")
          const allFiles = entries.flatMap(entry => 
            entry.files.map(file => ({
              file: file,
              bodyPart: entry.selectedPart || "", 
              message: entry.message || "",
              anciennete: entry.anciennete || "",
              taille: entry.taille || "",
              douleur: entry.douleur || ""
            }))
          );
          values.withPhotos = allFiles.length > 0;
          
          const fileObjects = allFiles.map(f => f.file);
          const metaArray = allFiles.map(f => ({
            bodyPart: f.bodyPart,
            message: f.message,
            anciennete: f.anciennete || "",
            taille: f.taille || "",
            douleur: f.douleur || ""
          }));
          console.log("THIS IS THE ONE THAT MATTERS fileObjects, metaArray", fileObjects, metaArray)
          const response = await addDocsByPatient2(
            {
              ...values,
              files: fileObjects,
              meta:metaArray,
              consentement: consentementFile
            },
            formConfig,
            (event: { loaded: number; total: number }) => {
              setProgress(Math.round((100 * event.loaded) / event.total));

              return event.loaded;
            }
          );
          
          if (response.status === "Success") {
            setDraft(false);
            setLoading(false);
            setPatientAdded(true);
            makeToast("success", response.message);
            setRefreshPatientInfo({ state: !refreshPatientInfo?.state });
            setOpenModal(false);
          } else if (response.status === "info") {
            //setDraft(false);
            setUpoloadProgFalse();
            setUploadToast(false);
            setModalPatientHasDemandInProg(true);
            makeToast("info", response.message);
            setLoading(false);
          } else {
            setLoading(false);
            makeToast("error", response.message);
            setOpenModal(false);
          }
        } else if (
          user?.type == "medecin" &&
          !_.isEmpty(teleexpertList) &&
          !formik.values.expertId
        ) {
          console.log("2")
          if (
            !formik.values.expertId &&
            !formik.values.forceIt &&
            !formik.values.isDraft &&
            !hasCurrentEvent
          ) {
            setConfirmationData({ values, formConfig });
            setLoading(false);
            setUpoloadProgFalse();
            setUploadToast(false);
            setShowConfirmation(true);
          } else {
            console.log("3")
            const allFiles = entries.flatMap(entry => 
            entry.files.map(file => ({
              file: file,
              bodyPart: entry.selectedPart || "", 
              message: entry.message || "",
              anciennete: entry.anciennete || "",
              taille: entry.taille || "",
              douleur: entry.douleur || ""
            }))
          );
            values.withPhotos = allFiles.length > 0;
          
            const fileObjects = allFiles.map(f => f.file);
            const metaArray = allFiles.map(f => ({
              bodyPart: f.bodyPart,
              message: f.message,
              anciennete: f.anciennete || "",
              taille: f.taille || "",
              douleur: f.douleur || ""
            }));
            const response = await addDocsByPatient2(
              {
                ...values,
                files: fileObjects,
                meta:metaArray,
                consentement: consentementFile
              },
              formConfig,
              (event: { loaded: number; total: number }) => {
                setProgress(Math.round((100 * event.loaded) / event.total));

                return event.loaded;
              }
            );
            if (response.status === "Success") {
              setDraft(false);
              setLoading(false);
              setPatientAdded(true);
              makeToast("success", response.message);
              setRefreshPatientInfo({ state: !refreshPatientInfo?.state });
              setOpenModal(false);
            } else if (response.status === "info") {
              //setDraft(false);
              setUpoloadProgFalse();
              setUploadToast(false);
              setModalPatientHasDemandInProg(true);
              makeToast("info", response.message);
              setLoading(false);
            } else {
              setLoading(false);
              makeToast("error", response.message);
              setOpenModal(false);
            }
          }
        } else if (
          user?.type == "medecin" &&
          !_.isEmpty(teleexpertList) &&
          formik.values.expertId
        ) {
          console.log("4")
          console.log("problem without imagess")
          const allFiles = entries.flatMap(entry => 
            entry.files.map(file => ({
              file: file,
              bodyPart: entry.selectedPart || "", 
              message: entry.message || "",
              anciennete: entry.anciennete || "",
              taille: entry.taille || "",
              douleur: entry.douleur || ""
            }))
          );

          const metaArray = allFiles.map(f => ({
            bodyPart: f.bodyPart,
            message: f.message,
            anciennete: f.anciennete || "",
            taille: f.taille || "",
            douleur: f.douleur || ""
          }));

          const fileObjects = allFiles.map(f => f.file);

          values.files = fileObjects;
          values.withPhotos = fileObjects.length > 0;
          const response = await addDocsByPatient2(
            {
              ...values,
              files: fileObjects,
              meta:metaArray,
              consentement: consentementFile
            },
            formConfig,
            (event: { loaded: number; total: number }) => {
              setProgress(Math.round((100 * event.loaded) / event.total));

              return event.loaded;
            }
          );
          if (values.withPhotos) {
            setUpoloadProg();
            setUploadToast(true);
          }
          if (response.status === "Success") {
            setDraft(false);
            setLoading(false);
            setPatientAdded(true);
            makeToast("success", response.message);
            setRefreshPatientInfo({ state: !refreshPatientInfo?.state });
            setOpenModal(false);
          } else if (response.status === "info") {
            //setDraft(false);
            makeToast("info", response.message);
            setLoading(false);
            setUpoloadProgFalse();
            setUploadToast(false);
            setModalPatientHasDemandInProg(true);
          } else {
            setLoading(false);
            makeToast("error", response.message);
            setOpenModal(false);
          }
        } else {
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        makeToast(
          "error",
          "Vous n'êtes pas autorisé à transmettre cette demande de téléexpertise! "
        );
        setOpenModal(false);
      }
    },

    validationSchema:
      !draft && getYupSchemaFromMetaData(formConfigDermatose, [], []),
  });
  const formik2 = useFormik({
    initialValues: {
      specialite: "dermatologie",
      type: "Tumeurs cutanees",
      constId: constId,
      withPhotos: true,
      doctor_id: user?._id,
      patientId: patientId,
      priseEncharge: false,
      files: files,
      isDraft: draft,
      forceIt: false,
      expertId: "",
      withConsentement: false,
    },
    onSubmit: async (values) => {
      try {
        const event = Array.isArray(currentEvent) ? currentEvent[0] : currentEvent;

        const expertId = (event as any)?.docExpert?._id;

        if (expertId) {
          formik2.setFieldValue("expertId", expertId);
        }
        console.log("Expert ID:", values.expertId);
        let formConfig = {};

        if (values.type === "Dermatose non tumorale") {
          formConfig = formConfigDermatose;
        } else if (values.type === "Tumeurs cutanees") {
          formConfig = formConfigTummerCutane;
        }

        const allFiles = entries.flatMap(e => e.files || []);
        values.withPhotos = allFiles.length > 0;
        values.isDraft = draft;
        console.log("allFiles in line 687", allFiles)
        console.log("values.files in line 687", values.files)
        console.log("values.isDraft", values.isDraft)
        //console.log("values.isDraft", values.isDraft)
        //console.log("draft", draft)
        //console.log("values", values)
        if (values.files && values.files.length === 0) {
          console.log("problems no photo line 693",  )
          console.log("values.files", values.files)
          console.log("values.files.length", values.files.length)
          values.withPhotos = false;
        }
        setLoading(true);
        if (values.withPhotos) {
          setUpoloadProg();
          setUploadToast(true);
        }
        if (user?.type == "medecinResponsable") {
          const response = await addDocsByPatient2(
            {
              ...values,
              consentement: consentementFile
            },
            formConfig,
            (event: { loaded: number; total: number }) => {
              setProgress(Math.round((100 * event.loaded) / event.total));

              return event.loaded;
            }
          );
          if (response.status === "Success") {
            setDraft(false);
            setLoading(false);
            setPatientAdded(true);
            makeToast("success", response.message);
            setRefreshPatientInfo({ state: !refreshPatientInfo?.state });
            setOpenModal(false);
          } else if (response.status === "info") {
            setDraft(false);
            setUpoloadProgFalse();
            setUploadToast(false);
            setModalPatientHasDemandInProg(true);
            makeToast("info", response.message);
            setLoading(false);
          } else {
            setLoading(false);
            makeToast("error", response.message);
            setOpenModal(false);
          }
        } else if (user?.type == "medecin" && _.isEmpty(teleexpertList)) {
          const allFiles = entries.flatMap(entry => 
            entry.files.map(file => ({
              file: file,
              bodyPart: entry.selectedPart || "", 
              message: entry.message || "",
              anciennete: entry.anciennete || "",
              taille: entry.taille || "",
              douleur: entry.douleur || ""
            }))
          );
          values.withPhotos = allFiles.length > 0;
          
          const fileObjects = allFiles.map(f => f.file);
          const metaArray = allFiles.map(f => ({
            bodyPart: f.bodyPart,
            message: f.message,
            anciennete: f.anciennete || "",
            taille: f.taille || "",
            douleur: f.douleur || ""
          }));
          console.log("THIS IS THE ONE THAT MATTERS fileObjects, metaArray", fileObjects, metaArray)
          const response = await addDocsByPatient2(
            {
              ...values,
              files: fileObjects,
              meta:metaArray,
              consentement: consentementFile
            },
            formConfig,
            (event: { loaded: number; total: number }) => {
              setProgress(Math.round((100 * event.loaded) / event.total));

              return event.loaded;
            }
          );
          if (response.status === "Success") {
            setDraft(false);
            setLoading(false);
            setPatientAdded(true);
            makeToast("success", response.message);
            setRefreshPatientInfo({ state: !refreshPatientInfo?.state });
            setOpenModal(false);
          } else if (response.status === "info") {
            //setDraft(false);
            setUpoloadProgFalse();
            setUploadToast(false);
            setModalPatientHasDemandInProg(true);
            makeToast("info", response.message);
            setLoading(false);
          } else {
            setLoading(false);
            makeToast("error", response.message);
            setOpenModal(false);
          }
        } else if (
          user?.type == "medecin" &&
          !_.isEmpty(teleexpertList) &&
          !formik2.values.expertId
        ) {
          if (
            !formik2.values.expertId &&
            !formik2.values.forceIt &&
            !formik2.values.isDraft &&
            !hasCurrentEvent
          ) {
            setConfirmationData({ values, formConfig });
            setLoading(false);
            setUpoloadProgFalse();
            setUploadToast(false);
            setShowConfirmation(true);
          } else {
            const allFiles = entries.flatMap(entry => 
              entry.files.map(file => ({
                file: file,
                bodyPart: entry.selectedPart || "", 
                message: entry.message || "",
                anciennete: entry.anciennete || "",
                taille: entry.taille || "",
                douleur: entry.douleur || ""
              }))
            );
            values.withPhotos = allFiles.length > 0;
            
            const fileObjects = allFiles.map(f => f.file);
            const metaArray = allFiles.map(f => ({
              bodyPart: f.bodyPart,
              message: f.message,
              anciennete: f.anciennete || "",
              taille: f.taille || "",
              douleur: f.douleur || ""
            }));

            const response = await addDocsByPatient2(
              {
                ...values,
                files: fileObjects,
                meta:metaArray,
                consentement: consentementFile
              },
              formConfig,
              (event: { loaded: number; total: number }) => {
                setProgress(Math.round((100 * event.loaded) / event.total));

                return event.loaded;
              }
            );
            if (response.status === "Success") {
              setDraft(false);
              setLoading(false);
              setPatientAdded(true);
              makeToast("success", response.message);
              setRefreshPatientInfo({ state: !refreshPatientInfo?.state });
              setOpenModal(false);
            } else if (response.status === "info") {
              //setDraft(false);
              setUpoloadProgFalse();
              setUploadToast(false);
              setModalPatientHasDemandInProg(true);
              makeToast("info", response.message);
              setLoading(false);
            } else {
              setLoading(false);
              makeToast("error", response.message);
              setOpenModal(false);
            }
          }
        } else if (
          user?.type == "medecin" &&
          !_.isEmpty(teleexpertList) &&
          formik2.values.expertId
        ) {
          console.log("CONTAINER LINE 772--------------------------------------------------")
          console.log("Submitting with expertId:", formik2.values.expertId);
          console.log("Submitting with values:", values);
          const allFiles = entries.flatMap(entry => 
            entry.files.map(file => ({
              file: file,
              bodyPart: entry.selectedPart || "", 
              message: entry.message || "",
              anciennete: entry.anciennete || "",
              taille: entry.taille || "",
              douleur: entry.douleur || ""
            }))
          );

          const metaArray = allFiles.map(f => ({
            bodyPart: f.bodyPart,
            message: f.message,
            anciennete: f.anciennete || "",
            taille: f.taille || "",
            douleur: f.douleur || ""
          }));

          const fileObjects = allFiles.map(f => f.file);

          values.withPhotos = fileObjects.length > 0;
          console.log("THIS IS THE ONE THAT MATTERS fileObjects, metaArray", fileObjects, metaArray)
          const response = await addDocsByPatient2(
            {
              ...values,
              files: fileObjects,
              meta:metaArray,
              consentement: consentementFile
            },
            formConfig,
            (event: { loaded: number; total: number }) => {
              setProgress(Math.round((100 * event.loaded) / event.total));

              return event.loaded;
            }
          );
          //const response = await addDemandByReqDoctor(values, formConfig);
          // const response = await addDocsByPatient2(
          //   values,
          //   formConfig,
          //   (event: { loaded: number; total: number }) => {
          //     setProgress(Math.round((100 * event.loaded) / event.total));
          //     return event.loaded;
          //   }
          // );
          if (response.status === "Success") {
            setDraft(false);
            setLoading(false);
            setPatientAdded(true);
            makeToast("success", response.message);
            setRefreshPatientInfo({ state: !refreshPatientInfo?.state });
            setOpenModal(false);
          } else if (response.status === "info") {
            //setDraft(false);
            setUpoloadProgFalse();
            setUploadToast(false);
            setModalPatientHasDemandInProg(true);
            makeToast("info", response.message);
            setLoading(false);
          } else {
            setLoading(false);
            makeToast("error", response.message);
            setOpenModal(false);
          }
        } else {
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        makeToast(
          "error",
          "Vous n'êtes pas autorisé à transmettre cette demande de téléexpertise! "
        );
        setOpenModal(false);
      }
    },

    validationSchema: !draft
      ? getYupSchemaFromMetaData(formConfigTummerCutane, [], [])
      : null,
  });

  return !uploadToast ? (
    <>
      <form
        className="w-11/12 max-w-lg mt-4 space-y-4 overflow-y-auto min-h-0 pb-32 "
        onSubmit={
          formik.values.type === "Dermatose non tumorale"
            ? formik.handleSubmit
            : formik2.handleSubmit
        }
      >
        {currentStep === 1 && (
          <div className="flex flex-col w-full text-base">
            Sélectionner la spécialité correspondant à votre demande :
            <Select
              value={formik.values.specialite}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              id="specialite"
              text={"Sélectionner  une spécialité"}
              className="relative mb-2 mt-2"
              options={specialites}
              required={true}
              style={{ cursor: "pointer" }}
            ></Select>
            {formik.values.specialite === "dermatologie" && (
              <>
                Sélectionner le type de lésion correspondant :
                <Select
                  value={formik.values.type}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  id="type"
                  text={"Type de lésion"}
                  className="relative mb-2 mt-2"
                  options={category}
                  required={true}
                  style={{ cursor: "pointer" }}
                ></Select>
                
              </>
                )}

                <div className="flex items-center gap-3 w-fit mt-2">
                  <label
                    htmlFor="file-upload"
                    className="flex items-center gap-2 cursor-pointer group"
                  >
                    <div className={`p-2 rounded-full transition-colors ${
                      consentementFile ? "bg-green-100" : "bg-blue-50 group-hover:bg-blue-100"
                    }`}>
                      {consentementFile ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                        </svg>
                      )}
                    </div>

                    <span className={`text-sm font-medium ${consentementFile ? "text-green-700" : "text-gray-600"}`}>
                      {consentementFile
                        ? `Fichier: ${consentementFile.name}`
                        : "Importer document consentement"}
                    </span>
                  </label>
                </div>

                <input
                  type="file"
                  id="file-upload"
                  onChange={handleFileChange}
                  className="hidden"
                />

                <CameraCapture
                  onCapture={(file) => {
                    setConsentementFile(file);
                    formik.setFieldValue("withConsentement", true);
                    formik2.setFieldValue("withConsentement", true);
                    console.log("Photo capturée:", file);
                  }}
                />
              </div>
            )}                

        {formik.values.specialite === "dermatologie" &&
          formik.values.type === "Dermatose non tumorale" &&
          currentStep === 1 && (
            <>
              <RecursiveContainer
                genre={gender}
                config={formConfigDermatose}
                formik={formik}
              />
              <Button
                status="primary"
                className="float-right flexCenter mb-5"
                width="200px"
                height="50px"
                onClick={() => setCurrentStep(2)}
                disabled={!formik.isValid}
              >
                Suivant
              </Button>
            </>
          )}
        {formik.values.specialite === "dermatologie" &&
          formik.values.type === "Dermatose non tumorale" &&
          currentStep === 2 && (
            <>
              <div className="flex flex-col items-center space-y-6 p-4 w-full max-w-md">
                <Stepper currentEntry={currentEntry} />
                {/* Human Card */}
                {!confirm && (
                  <div className="body-step flex flex-col items-center space-y-6 w-fit">
                    <HumanCard
                      selectedPart={currentEntry.selectedPart}
                      onSelectPart={(part) => {
                        setEntries(prev => {
                          const copy = prev.map((entry, idx) =>
                            idx === currentIndex
                              ? { ...entry, selectedPart: part }
                              : entry
                          );

                          return copy;
                        });
                      }}
                    />

                    {currentEntry.selectedPart && (
                      <button
                        type="button"
                        className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition-colors duration-300"
                        onClick={() => setConfirm(true)}
                      >
                        ✔ Confirmer la zone
                      </button>
                    )}
                  </div>
                )}

                {/* Upload Section */}
                {confirm && (
                  <section className="addDoc flex flex-col items-center w-full">
                    <div
                      {...getRootProps({
                        className:
                          "dropzone flexCenter w-full border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 transition-colors duration-300",
                      })}
                    >
                      <input {...getInputProps()} />
                      <p className="text-center text-gray-500 ">
                        Déposez ici vos images de cette lésion.
                        <br />
                        <span className="text-sm text-gray-400">
                          Formats acceptés (.png, .jpg, .jpeg, .webp)
                        </span>
                      </p>
                    </div>

                    {/* Show previews if any */}
                    {currentEntry.files.length > 0 && (
                      <aside className="thumbsContainer flex flex-wrap gap-4 mt-4 w-full">
                        {currentEntry.files.map((file, index) => (
                          <div
                            key={index}
                            className="w-24 h-24 border border-gray-300 rounded-lg overflow-hidden flex items-center justify-center"
                          >
                            <img
                              src={URL.createObjectURL(file)}
                              alt={`preview-${index}`}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        ))}
                      </aside>
                    )}

                    {/* Message input */}
                    {currentEntry.files.length > 0 && (
                      <>
                        {/* Ancienneté de la lésion */}
                        <label className="mt-4 block">
                          Ancienneté de la lésion <span className="text-red-500">(*)</span>
                        </label>
                        <input
                          type="text"
                          placeholder=""
                          value={entries[currentIndex].anciennete}
                          onChange={(e) => {
                            const newEntries = [...entries];
                            newEntries[currentIndex].anciennete =
                              e.target.value;
                            setEntries(newEntries);
                          }}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 mt-4"
                        />

                        {/* Taille */}
                        <label className="mt-4">Taille (mm) <span className="text-red-500">(*)</span></label>
                        <input
                          type="number"
                          placeholder=""
                          value={entries[currentIndex].taille}
                          onChange={(e) => {
                            const newEntries = [...entries];
                            newEntries[currentIndex].taille = e.target.value;
                            setEntries(newEntries);
                          }}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                        />

                        {/* Douleur */}
                        <label className="mt-4">Douleur <span className="text-red-500">(*)</span></label>
                        <div className="flex gap-4">
                          {["oui", "non", "inconnue"].map((val) => (
                            <label
                              key={val}
                              className="flex items-center gap-1 mt-3"
                            >
                              <input
                                type="radio"
                                name={`douleur-${currentIndex}`}
                                value={val}
                                checked={entries[currentIndex].douleur === val}
                                required
                                onChange={() => {
                                  const newEntries = [...entries];
                                  newEntries[currentIndex].douleur = val as
                                    | "oui"
                                    | "non"
                                    | "inconnue";
                                  setEntries(newEntries);
                                }}
                              />
                              {val}
                            </label>
                          ))}
                        </div>
                        <input
                          type="text"
                          placeholder="Écrire un message pour l'image..."
                          value={currentEntry.message}
                          onChange={(e) => {
                            const newEntries = [...entries];
                            newEntries[currentIndex].message = e.target.value;
                            setEntries(newEntries);
                          }}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 mt-4"
                        />
                      </>
                    )}

                    {/* Ajouter une autre image button */}
                    {currentEntry.files.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          // Go to next entry
                          setEntries([
                            ...entries,
                            {
                              selectedPart: null,
                              files: [],
                              message: "",
                              anciennete: "",
                              taille: "",
                              douleur: "inconnue",
                            },
                          ]);
                          setCurrentIndex(entries.length); // point to new entry
                          setConfirm(false); // back to human card
                        }}
                        className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition-colors duration-300 mt-4 mb-3"
                      >
                        Ajouter une autre lésion
                      </button>
                    )}
                    {currentEntry.files.length > 0 && qualityData && (
                      <>
                        <QualityAnalysis data={qualityData} />
                        {qualityData?.overall_quality !== "accept" && (
                          <div className="flex justify-center">
                            <button
                              type="button"
                              onClick={removeLastPhoto}
                              className="mt-4 mb-4 px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                            >
                              Reprendre la photo
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </section>
                )}

                {/* Display all previous entries */}
                {currentEntry.files.length > 0 && (
                  <Carousel entries={entries} onDeleteImage={handleDeleteImage} />
                )}
              </div>

              {files && files.length === 0 && (
                <Input
                  id="withPhotos"
                  value={`${formik.values.withPhotos}`}
                  type={"checkbox"}
                  className="m-1"
                  labelText={"Ajouter les photos plus tard"}
                  onChange={() => {
                    setTakePic(!takePic);
                    formik.values.withPhotos = !takePic;
                  }}
                  onBlur={formik.handleBlur}
                  style={{ cursor: "pointer" }}
                />
              )}

              {(user?.type === "medecin" || user?.type === "medecinResponsable") && (
  <>
    {hasCurrentEvent ? (
      // Case: There is an event today
      <div className="flex flex-col w-full items-start gap-2">
        <img src={alert} alt="alerte" width="40" />
        <p style={{ fontSize: "17px", color: "#4565f6", textAlign: "justify" }}>
          Aujourd'hui est une journée d'événement. Votre demande sera automatiquement affectée à l'expert :{" "}
          <strong>
            {currentEvent[0]?.docExpert?.lastName} {currentEvent[0]?.docExpert?.firstName}
          </strong>
          .
        </p>
      </div>
    ) : _.isEmpty(teleexpertList) ? (
      // Case: No event today and no experts available
      <div className="flex items-start gap-3 w-full">
        <img src={alert} alt="alerte" className="shrink-0 mt-1" width="40" />
        <p style={{ fontSize: "17px", color: "#4565f6", textAlign: "justify" }}>
          {user?.groupId
            ? "Aucun expert n'est disponible dans votre groupe, votre demande sera transmise à un médecin expert de notre réseau."
            : "Aucun expert n'est disponible dans votre département, votre demande sera transmise à un médecin expert de notre réseau."}
        </p>
      </div>
    ) : (
      // Case: No event today but experts are available
      <div className="flex flex-col w-full">
        <Select
          id="expertId"
          value={formik.values.expertId}
          onChange={formik.handleChange}
          text="Sélectionner un téléexpert"
          className="relative mb-2 mt-2"
          options={
            _.isEmpty(previousDoctor)
              ? teleexpertList?.map((e) => ({
                  value: e._id,
                  label: `${e.lastName} ${e.firstName} (${e.departement})`,
                }))
              : teleexpertList
                  ?.map((e) => ({
                    value: e._id,
                    label: `${e.lastName} ${e.firstName} (${e.departement})`,
                  }))
                  .concat(previousDoctor)
          }
        />
        {!formik.values.expertId && (
          <div className="flex items-start gap-3 w-full">
            <img src={alert} alt="alerte" className="shrink-0 mt-1" width="40" />
            <p style={{ fontSize: "17px", color: "#4565f6", textAlign: "justify" }}>
              {user?.groupId
                ? groupData?.doctorId?.length === 1
                  ? "Aucun expert de votre département n'a été sélectionné, votre demande sera transmise à un médecin expert de notre réseau national."
                  : "Aucun expert de votre groupe n'a été sélectionné, votre demande sera transmise à un médecin expert de notre réseau national."
                : "Aucun expert de votre département n'a été sélectionné, votre demande sera transmise à un médecin expert de notre réseau national."}
            </p>
          </div>
        )}
      </div>
    )}
  </>
)}
              <div className="w-full flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 mt-4">
  
  {/* LEFT */}
  <Button
    status="primary"
    className="w-full sm:w-auto px-8 flexCenter"
    height="50px"
    onClick={() => setCurrentStep(1)}
    disabled={!formik.isValid}
  >
    Précédent
  </Button>

  {/* RIGHT */}
  <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 w-full sm:w-auto justify-end">
    
    <Button
      status="secondary"
      className="w-full sm:w-auto px-8 flexCenter"
      height="50px"
      type="submit"
      disabled={loading}
      onClick={() => setDraft(true)}
    >
      {loading && draft ? (
        <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-purple-500"></div>
      ) : (
        "Enregistrer brouillon"
      )}
    </Button>

    <Button
      status="primary"
      className="w-full sm:w-auto px-8 flexCenter"
      height="50px"
      disabled={
        !formik.isValid ||
        formik.values.withConsentement === false ||
        (takePic && currentEntry.files.length === 0) ||
        loading
      }
    >
      {loading && !draft ? (
        <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-purple-500"></div>
      ) : (
        "Envoyer la demande"
      )}
    </Button>

  </div>
</div>
            </>
          )}
        {formik.values.specialite === "dermatologie" &&
          formik.values.type === "Tumeurs cutanees" &&
          currentStep === 1 && (
            <>
              <RecursiveContainer
                genre={gender}
                config={formConfigTummerCutane}
                formik={formik2}
              />
              <Button
                status="primary"
                className="float-right flexCenter mb-5"
                width="200px"
                height="50px"
                onClick={() => setCurrentStep(2)}
                disabled={!formik2.isValid}
              >
                Suivant
              </Button>
            </>
          )}
        {currentStep === 2 &&
          formik.values.specialite === "dermatologie" &&
          formik.values.type === "Tumeurs cutanees" && (
            <>
              <div className="w-full max-w-4xl mx-auto px-6 py-8">
                <Stepper currentEntry={currentEntry} />
                {/* Human Card */}
                {!confirm && (
                  <div className="body-step flex flex-col items-center space-y-6 w-full">
                    <HumanCard
                      selectedPart={currentEntry.selectedPart}
                      onSelectPart={(part) => {
                        setEntries(prev => {
                          const copy = prev.map((entry, idx) =>
                            idx === currentIndex
                              ? { ...entry, selectedPart: part }
                              : entry
                          );

                          return copy;
                        });
                      }}
                    />

                    {currentEntry.selectedPart && (
                      <button
                        type="button"
                        className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition-colors duration-300"
                        onClick={() => setConfirm(true)}
                      >
                        ✔ Confirmer la zone
                      </button>
                    )}
                  </div>
                )}

                {/* Upload Section */}
                {confirm && (
                  <section className="addDoc flex flex-col items-center w-full">
                    <div
                      {...getRootProps({
                        className:
                          "dropzone flexCenter w-full border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 transition-colors duration-300",
                      })}
                    >
                      <input {...getInputProps()} />
                      <p className="text-center text-gray-500">
                        Déposez ici vos images de cette lésion.
                        <br />
                        <span className="text-sm text-gray-400">
                          Formats acceptés (.png, .jpg, .jpeg, .webp)
                        </span>
                      </p>
                    </div>

                    {/* Show previews if any */}
                    {currentEntry.files.length > 0 && (
                      <aside className="thumbsContainer flex flex-wrap gap-4 mt-4 w-full">
                        {currentEntry.files.map((file, index) => (
                          <div
                            key={index}
                            className="w-24 h-24 border border-gray-300 rounded-lg overflow-hidden flex items-center justify-center"
                          >
                            <img
                              src={URL.createObjectURL(file)}
                              alt={`preview-${index}`}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        ))}
                      </aside>
                    )}

                    {/* Message input */}
                    {currentEntry.files.length > 0 && (
                      <>
                        {/* Ancienneté de la lésion */}
                        <label className="mt-4 ">Ancienneté de la lésion <span className="text-red-500">(*)</span></label>
                        <input
                          type="text"
                          placeholder=""
                          value={entries[currentIndex].anciennete}
                          onChange={(e) => {
                            const newEntries = [...entries];
                            newEntries[currentIndex].anciennete =
                              e.target.value;
                            setEntries(newEntries);
                          }}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 mt-4"
                        />

                        {/* Taille */}
                        <label className="mt-4">Taille (mm) <span className="text-red-500">(*)</span></label>
                        <input
                          type="number"
                          placeholder=""
                          value={entries[currentIndex].taille}
                          onChange={(e) => {
                            const newEntries = [...entries];
                            newEntries[currentIndex].taille = e.target.value;
                            setEntries(newEntries);
                          }}
                          required
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                        />

                        {/* Douleur */}
                        <label className="mt-4">Douleur <span className="text-red-500">(*)</span> </label>
                        <div className="flex gap-4">
                          {["oui", "non", "inconnue"].map((val) => (
                            <label
                              key={val}
                              className="flex items-center gap-1 mt-3"
                            >
                              <input
                                type="radio"
                                name={`douleur-${currentIndex}`}
                                value={val}
                                checked={entries[currentIndex].douleur === val}
                                onChange={() => {
                                  const newEntries = [...entries];
                                  newEntries[currentIndex].douleur = val as
                                    | "oui"
                                    | "non"
                                    | "inconnue";
                                  setEntries(newEntries);
                                }}
                                required
                              />
                              {val}
                            </label>
                          ))}
                        </div>
                        <input
                          type="text"
                          placeholder="Écrire un message pour l'image..."
                          value={currentEntry.message}
                          onChange={(e) => {
                            const newEntries = [...entries];
                            newEntries[currentIndex].message = e.target.value;
                            setEntries(newEntries);
                          }}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 mt-4"
                        />
                      </>
                    )}

                    {/* Ajouter une autre image button */}
                    {currentEntry.files.length > 0 && (
                      <button
                        type="button"
                        onClick={() => {
                          // Go to next entry
                          setEntries([
                            ...entries,
                            {
                              selectedPart: null,
                              files: [],
                              message: "",
                              anciennete: "",
                              taille: "",
                              douleur: "inconnue",
                            },
                          ]);
                          setCurrentIndex(entries.length); // point to new entry
                          setConfirm(false); // back to human card
                        }}
                        className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition-colors duration-300 mt-5 mb-4 self-center"
                      >
                        Ajouter une autre lésion
                      </button>
                    )}
                  </section>
                )}

                {currentEntry.files.length > 0 && qualityData && (
                  <>
                    <QualityAnalysis data={qualityData} />

                    {qualityData?.overall_quality !== "accept" && (
                      <div className="flex justify-center">
                        <button
                          type="button"
                          onClick={removeLastPhoto}
                          className="mt-4 mb-4 px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                        >
                          Reprendre la photo
                        </button>
                      </div>
                    )}
                  </>
                )}

                {/* Display all previous entries */}
                {currentEntry.files.length > 0 && (
                  <Carousel entries={entries} onDeleteImage={handleDeleteImage} />
                )}
              </div>
              {files && files.length === 0 && (
                <Input
                  id="withPhotos"
                  value={`${formik2.values.withPhotos}`}
                  type={"checkbox"}
                  className="m-1"
                  labelText={"Ajouter les photos plus tard"}
                  onChange={() => {
                    setTakePic(!takePic);
                    formik2.values.withPhotos = !takePic;
                  }}
                  onBlur={formik.handleBlur}
                />
              )}

               {(user?.type === "medecin" || user?.type === "medecinResponsable") && (
                <>
                  {hasCurrentEvent ? (
                    // Case: There is an event today
                    <div className="flex flex-col w-full items-start gap-2">
                      <img src={alert} alt="alerte" width="40" />
                      <p style={{ fontSize: "17px", color: "#4565f6", textAlign: "justify" }}>
                        Aujourd'hui est une journée d'événement. Votre demande sera automatiquement affectée à l'expert :{" "}
                        <strong>
                          {currentEvent[0]?.docExpert?.lastName} {currentEvent[0]?.docExpert?.firstName}
                        </strong>
                        .
                      </p>
                    </div>
                  ) : _.isEmpty(teleexpertList) ? (
                    // Case: No event today and no experts available
                    <div className="flex items-start gap-3 w-full">
                      <img src={alert} alt="alerte" className="shrink-0 mt-1" width="40" />
                      <p style={{ fontSize: "17px", color: "#4565f6", textAlign: "justify" }}>
                        {user?.groupId
                          ? "Aucun expert n'est disponible dans votre groupe, votre demande sera transmise à un médecin expert de notre réseau."
                          : "Aucun expert n'est disponible dans votre département, votre demande sera transmise à un médecin expert de notre réseau."}
                      </p>
                    </div>
                  ) : (
                    // Case: No event today but experts are available
                    <div className="flex flex-col w-full">
                      <Select
                        id="expertId"
                        value={formik2.values.expertId}
                        onChange={formik2.handleChange}
                        text="Sélectionner un téléexpert"
                        className="relative mb-2 mt-2"
                        options={
                          _.isEmpty(previousDoctor)
                            ? teleexpertList?.map((e) => ({
                                value: e._id,
                                label: `${e.lastName} ${e.firstName} (${e.departement})`,
                              }))
                            : teleexpertList
                                ?.map((e) => ({
                                  value: e._id,
                                  label: `${e.lastName} ${e.firstName} (${e.departement})`,
                                }))
                                .concat(previousDoctor)
                        }
                      />
                      {!formik2.values.expertId && (
                        <div className="flex items-start gap-3 w-full">
                          <img src={alert} alt="alerte" className="shrink-0 mt-1" width="40" />
                          <p style={{ fontSize: "17px", color: "#4565f6", textAlign: "justify" }}>
                            {user?.groupId
                              ? groupData?.doctorId?.length === 1
                                ? "Aucun expert de votre département n'a été sélectionné, votre demande sera transmise à un médecin expert de notre réseau national."
                                : "Aucun expert de votre groupe n'a été sélectionné, votre demande sera transmise à un médecin expert de notre réseau national."
                              : "Aucun expert de votre département n'a été sélectionné, votre demande sera transmise à un médecin expert de notre réseau national."}
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}

              <div className="w-full flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 mt-4">
                <Button
                  status="primary"
                  className="w-full sm:w-auto px-8 flexCenter"
                  //width="120px"
                  height="50px"
                  onClick={() => setCurrentStep(1)}
                >
                  Précédent
                </Button>

                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 w-full sm:w-auto justify-end">
                  <Button
                    status="secondary"
                    className="w-full sm:w-auto px-8 flexCenter"
                    //width="180px"
                    height="50px"
                    type="submit"
                    disabled={loading}
                    onClick={() => {
                      setDraft(true);
                    }}
                  >
                    {loading && draft ? (
                      <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-purple-500"></div>
                    ) : (
                      "Enregistrer brouillon "
                    )}
                  </Button>
                  <Button
                    status="primary"
                    className="w-full sm:w-auto px-8 flexCenter"
                    //width="180px"
                    height="50px"
                    disabled={
                      !draft &&
                      (!formik2.isValid ||
                        formik2.values.withConsentement == false ||
                        (takePic && currentEntry.files.length === 0) ||
                        loading)
                    }
                  >
                    {loading && !draft ? (
                      <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-purple-500"></div>
                    ) : (
                      "Envoyer la demande"
                    )}
                  </Button>

                </div>
              </div>
            </>
          )}
      </form>
      {
        <Modal
          showModal={showConfirmation}
          closeModal={() => setShowConfirmation(false)}
        >
          <div className="p-3">
            <h3 className="text-black text-center">
              Vous n'avez sélectionné aucun expert sur la liste. Êtes-vous sûr
              de vouloir continuer?
            </h3>
            <div className="flexCenter mt-6 buttons gap-x-6">
              <Button
                status="secondary"
                width={"119px"}
                height={"50px"}
                onClick={() => setShowConfirmation(false)}
              >
                Annuler
              </Button>
              <Button
                status="secondary"
                width={"119px"}
                height={"50px"}
                onClick={async () => {
                if (isSubmittingRef.current) return;

                isSubmittingRef.current = true;

                try {
                  const response = await addDocsByPatient2(
                    confirmationData.values,
                    confirmationData.formConfig,
                    (event: { loaded: number; total: number }) => {
                      setProgress(Math.round((100 * event.loaded) / event.total));
                      return event.loaded;
                    }
                  );

                  console.log(response);

                  if (response.status === "Success") {
                    setDraft(false);
                    setLoading(false);
                    setPatientAdded(true);
                    makeToast("success", response.message);
                    setRefreshPatientInfo({
                      state: !refreshPatientInfo?.state,
                    });
                    setOpenModal(false);
                  } else if (response.status === "info") {
                    setDraft(false);
                    setUpoloadProgFalse();
                    setUploadToast(false);
                    setModalPatientHasDemandInProg(true);
                    setShowConfirmation(false);
                    makeToast("info", response.message);
                    setLoading(false);
                  } else {
                    setLoading(false);
                    makeToast("error", response.message);
                    setOpenModal(false);
                  }
                } catch (error) {
                  console.error(error);
                } finally {
                  isSubmittingRef.current = false;
                }
              }}
              >
                Confirmer
              </Button>
            </div>
          </div>
        </Modal>
      }

      <Modal
        showModal={modalPatientHasDemandInProg}
        closeModal={() => setModalPatientHasDemandInProg(false)}
      >
        <div className="p-3 ">
          <h3 className="flexCenter text-black">
            Ce patient a déjà une demande de téléexpertise en cours.{" "}
            <br></br>{" "}
          </h3>
          <h3 className="flexCenter text-black">
            Souhaitez-vous confirmer l'envoi de cette nouvelle demande de
            téléexpertise?
          </h3>
          <div className="flexCenter mt-6 buttons gap-x-6">
            <Button
              status="secondary"
              width={"119px"}
              height={"50px"}
              onClick={() => setModalPatientHasDemandInProg(false)}
            >
              Annuler
            </Button>
            <Button
              status="secondary"
              type="button"
              width={"119px"}
              height={"50px"}
              onClick={async () => {
                if (isSubmittingRef.current) return;

                isSubmittingRef.current = true;

                try {
                  if (formik.values.type === "Dermatose non tumorale") {
                    await formik.setFieldValue("forceIt", true);
                    await formik.submitForm();
                  } else if (formik.values.type === "Tumeurs cutanees") {
                    await formik2.setFieldValue("forceIt", true);
                    await formik2.submitForm();
                  }
                } finally {
                  isSubmittingRef.current = false;
                }
              }}
            >
              Confirmer
            </Button>
          </div>
        </div>
      </Modal>

    </>
  ) : (
    <div className="w-full px-6  ">
      <div className="font-bold text-gray-700 ">
        Téléchargement d'images en cours...
      </div>
      <div className="w-full  bg-gray-300 rounded-full ">
        <div
          className={`${
            progress == 0 ? "" : "bg-Blue-Primary"
          } text-xs font-medium text-white text-center px-0.5 leading-none rounded-full`}
          style={{ width: `${progress}%` }}
        >
          {progress}%
        </div>
      </div>
    </div>
  );
};

export default RequestForm;
